<template>
  <BreadCrumb PageTitle="Account Settings" />
  <CoverImage />
  <TypeClientSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import CoverImage from "../../components/Generals/CoverImage.vue";
import TypeClientSettings from "@/components/Generals/AccountSettings/TypeClientSettings.vue";

export default defineComponent({
  name: "TypeClientSettingsPage",
  components: {
    BreadCrumb,
    CoverImage,
    TypeClientSettings,
  },
});
</script>